import BonusQuestionSectionContext from "@/components/pages/CartoonDetailPage/BonusQuestionSection/BonusQuestionSectionContext"
import { useCallback, useContext, useState } from "react"

interface UseGetCoinsProps {
  correctAnswers: string[]
  maxCoins: number
}

const useGetCoins = ({ correctAnswers, maxCoins }: UseGetCoinsProps) => {
  const { coins, setCoins, setAnswerState, answerState } = useContext(BonusQuestionSectionContext)
  const [attempt, setAttempt] = useState<number>(1)

  const calculatePoints = useCallback(
    (attemptNumber: number): number => {
      const pointsLostPerAttempt = 10
      const minPoints = 1
      const attemptPoints = maxCoins - (attemptNumber - 1) * pointsLostPerAttempt
      return attemptNumber > 3 ? minPoints : Math.max(attemptPoints, minPoints)
    },
    [maxCoins],
  )

  const handleCountCoins = useCallback(
    (userAnswers: string[]) => {
      const allCorrect =
        userAnswers.length === correctAnswers.length && userAnswers.every((answer) => correctAnswers.includes(answer))

      if (allCorrect) {
        setCoins(calculatePoints(attempt))
        setAnswerState("success")
      } else {
        setAttempt((prevAttempt) => prevAttempt + 1)
        setAnswerState("failure")
      }
    },
    [correctAnswers, setCoins, calculatePoints, attempt, setAnswerState],
  )

  return { handleCountCoins, coins, answerState, setAnswerState }
}

export default useGetCoins
